import { render } from "./ExperienceCard.vue?vue&type=template&id=47d7b650&ts=true"
import script from "./ExperienceCard.vue?vue&type=script&lang=ts"
export * from "./ExperienceCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/jh8oh.github.io/jh8oh.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__